import { render } from "./StoresSettingsRegister.vue?vue&type=template&id=3466824a&scoped=true"
import script from "./StoresSettingsRegister.vue?vue&type=script&lang=js"
export * from "./StoresSettingsRegister.vue?vue&type=script&lang=js"

import "./StoresSettingsRegister.vue?vue&type=style&index=0&id=3466824a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3466824a"]])

export default __exports__